import React from 'react';
import { Grid, Icon, Message } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import MarkAsCheckedButton from './MarkAsCheckedButton';
import { isDateOlderThan1Year } from 'Dates';
import useUser from '@behavior/init/getUserV2';
import {
  isEditor,
  isAdmin,
  isEnvironmentalExpert,
  isChemicalSafetyExpert,
} from '@behavior/init/selectors';

type UserDateActionRequiredProps = {
  values: any;
  isInventory?: boolean;
  setValidateOnChange: (value: boolean) => void;
  toggleValidationMessage: () => void;
  setMarkAsChecked: () => void;
  submitForm: () => void;
};

const UserDateActionRequired: React.FC<UserDateActionRequiredProps> = ({
  values,
  isInventory,
  setValidateOnChange,
  toggleValidationMessage,
  setMarkAsChecked,
  submitForm,
}) => {
  const { t } = useTranslation();
  const { user } = useUser();
  const isActionRequired =
    values.id !== null &&
    isInventory &&
    (values.checkDte === null || isDateOlderThan1Year(values.checkDte));

  return isActionRequired ? (
    <Grid.Row>
      <div className="warningMessageRow">
        <Message color="yellow">
          <Icon color="orange" name="warning sign" />
          {t('table.nonChecked.footer.warning')}
        </Message>
        <div className="markAsCheckedButtonStyle">
          {user &&
            (isEditor(user) ||
              isAdmin(user) ||
              isEnvironmentalExpert(user) ||
              isChemicalSafetyExpert(user)) && (
              <MarkAsCheckedButton
                setValidateOnChange={setValidateOnChange}
                toggleValidationMessage={toggleValidationMessage}
                setMarkAsChecked={setMarkAsChecked}
                submitForm={submitForm}
              />
            )}
        </div>
      </div>
    </Grid.Row>
  ) : null;
};

export default UserDateActionRequired;
